@if (hasLegend()) {
  <aside class="holes-view__legend" [attr.data-attr]="'holes-legend-' + view()">
    <app-holes-legend-panel>
      <p class="holes-view__soon">{{ 'HOLES_TAB.COMING_SOON' | translate }}</p>
    </app-holes-legend-panel>
  </aside>
}

<section class="holes-view__panel" [attr.data-attr]="'holes-panel-' + view()">
  <div class="holes-view__empty">
    <h3 class="holes-view__title">{{ labelKeys[view()] | translate }}</h3>
    <p class="holes-view__soon">{{ 'HOLES_TAB.COMING_SOON' | translate }}</p>
    @if (state.isLoading()) {
      <p class="holes-view__count">…</p>
    } @else if (state.loadError()) {
      <p class="holes-view__count holes-view__count--error">{{ 'HOLES_TAB.LOAD_ERROR' | translate }}</p>
    } @else {
      <p class="holes-view__count" data-attr="holes-count">
        {{ 'HOLES_TAB.HOLES_LOADED' | translate: { count: state.holes().length } }}
      </p>
    }
  </div>
</section>
